<template>
  <config-base class="opc-lm" ref="baseRef" :on="$listeners">
    <template #config>
      <capacity-config-list :config-plan-type="planType" :config-capacity-key="capacityKey" :capacity-unit-i18n-key="capacityUnitI18nKey" :show-monthly-price-from-cycle="true"></capacity-config-list>
      <preview-payment class="opc-lm__preview-payment" />
    </template>
  </config-base>
</template>

<script>
import _, {get, map} from "lodash";
import {mapGetters} from "vuex";
import planCommon from '@/plans/LARGE_MEETING/mixin';
import {getPlanTotalLicense} from "@/common/service/validate";
import {getNeedFilterCapacityList} from '@/common/product';
import {computedLargeMeetingPlans} from "@/common/service/computers/plans/large-meeting";
import plansMixin from "@/plans/mx/plan";
import ConfigList from "@/components/capacity/config-list.vue";
import ConfigBase from "@/plans/LARGE_MEETING/config/base.vue";
import PreviewPayment from '@/views/checkout/payment/preview-payment';

const CapacityConfigList = {
  name: 'CapacityConfigList',
  extends: ConfigList,
  mixins: [planCommon],
  computed: {
    ...mapGetters(['getCurrentMeetingPlans', 'getCurrentBasePlanInfo', 'boughtPlans', 'hasBoughtDependPlan', 'isProFreeTrialAddAddonCase', 'basicConfig', 'currentEditPlan']),
    boughtCurrentPlans() {
      return computedLargeMeetingPlans(this.boughtPlans)
    },
    planList() {
      const beforeList = _.filter(this.planMapFlat, (p) => {
        const isCurrentPlanType = p.type === this.planType;
        const isSupportCapacity = this.supportCapacity.includes(p[this.capacityKey]);
        const isBoughtCapacity = map(this.boughtCurrentPlans.filter(p => !p.isFreeTrial), this.capacityKey).includes(p[this.capacityKey]);
        const needFilterCapacity = getNeedFilterCapacityList(this.getCurrentBasePlanInfo?.plans).includes(p[this.capacityKey]);
        return isCurrentPlanType && isSupportCapacity && !needFilterCapacity && !isBoughtCapacity;
      })

      const afterList = _.filter(beforeList, (p) => {
        const currentCapacity = this.currentEditPlan?.[this.capacityKey];
        const isBulkLicenseAccount = this.basicConfig?.isBulkLicenseAccount;

        if (isBulkLicenseAccount) {
          return currentCapacity === p?.[this.capacityKey];
        }

        return true;
      });

      return !afterList?.length ? beforeList : afterList;
    },
    mx_licenseTips() {
      return this.totalLimitDesc;
    },
    currentBasePlans() {
      return this.getCurrentMeetingPlans.length ? this.getCurrentMeetingPlans : this.getCurrentBasePlanInfo?.plans;
    },
    editTotalLimitDesc() {
      const basePlanNameKey = get(this.currentBasePlans, [0, 'parentPlanNameKey']) || get(this.currentBasePlans, [0, 'planNameKey']) || get(this.currentBasePlans, [0, 'typeNameKey'])
      return this.$t(
        (this.hasBoughtDependPlan && !this.isProFreeTrialAddAddonCase) ?
        'billing.addon_license_limit_tips' :
        'billing.addon_license_limit_tips_without_contact',
        [this.title, this.$t(basePlanNameKey)])
    }
  },
  methods: {
    getPlanList() {
      return this.planMapFlat.filter((p) => {
        const isCurrentPlanType = p.type === this.planType;
        const isSupportCapacity = this.supportCapacity.includes(p[this.capacityKey]);
        const isBoughtCapacity = map(this.boughtCurrentPlans, this.capacityKey).includes(p[this.capacityKey]);
        const needFilterCapacity = getNeedFilterCapacityList(this.getCurrentBasePlanInfo?.plans).includes(p[this.capacityKey])
        return isCurrentPlanType && isSupportCapacity && !needFilterCapacity && !isBoughtCapacity;
      });
    },
    handleLicenseChange(license, _, { capacity }) {
      const condition = license >= this.mx_getMaxHosts() && this.mx_getMaxHosts() !== 999;
      this.$set(this.mx_license_capacityAlertMap, capacity, condition ? this.editTotalLimitDesc : "");
      if (this.isProFreeTrialAddAddonCase) {
        this.mx_syncBasePlanLicenseForProFreeTrialAddonCase(license);
      }
    },
    mx_getMaxHosts() {
      if (this.isProFreeTrialAddAddonCase) {
        return 999
      }
      return getPlanTotalLicense(this.currentBasePlans || []) || 999;
    },
    mx_getDeleteVisible(capacity){
      return !(
        this.selectedPlanList?.length === 1
        && capacity === this.selectedPlanList?.[0].capacity)
    },
  },
  created() {
    window.__large = this
  }
}
export default {
  mixins: [plansMixin, planCommon],
  components: { PreviewPayment, ConfigBase, CapacityConfigList }
};
</script>

<style lang="scss">
.opc-lm {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
